/* eslint-disable */
import { RINGS_TYPE } from '@ringcentral-integration/commons/modules/RingtoneConfiguration/const';
export default {
  [RINGS_TYPE.Phone_Ring1]: '電話のベル1',
  [RINGS_TYPE.Phone_Ring2]: '電話のベル2',
  [RINGS_TYPE.Acoustic_Dreams]: 'アコースティック',
  [RINGS_TYPE.Air_Raid]: '空襲',
  [RINGS_TYPE.Allusive]: 'ひらめき',
  [RINGS_TYPE.Attention]: '注意',
  [RINGS_TYPE.Blub_Blub]: 'スイミング',
  [RINGS_TYPE.Buzzy]: 'バジー',
  [RINGS_TYPE.Channel_Open]: 'チャンネルオープン',
  [RINGS_TYPE.Contemplation]: '黙想',
  [RINGS_TYPE.Crystal_Ball]: 'クリスタル',
  [RINGS_TYPE.Disco]: 'ディスコ',
  [RINGS_TYPE.Door_Bell]: 'ドアベル',
  [RINGS_TYPE.Fairy]: '妖精',
  [RINGS_TYPE.Fast_Bells]: '速い鐘',
  [RINGS_TYPE.High_Gong]: 'ハイゴング',
  [RINGS_TYPE.Immersion]: 'ピアノの音',
  [RINGS_TYPE.Indeed]: '確かに',
  [RINGS_TYPE.Lazy_Day]: 'リラックス',
  [RINGS_TYPE.Neural_Funk]: 'ニューロン',
  [RINGS_TYPE.Nice]: 'いいね',
  [RINGS_TYPE.Ring]: 'ベルの音',
  [RINGS_TYPE.Ringing_Bells]: '鳴る鐘',
  [RINGS_TYPE.Simple]: 'シンプル',
  [RINGS_TYPE.Soothing]: '癒し',
  [RINGS_TYPE.Sunshine]: 'サンシャイン',
  [RINGS_TYPE.Off]: 'オフ',
  add: '追加',
  delete: '削除',
  play: '再生',
  cancel: 'キャンセル',
  confirmToDelete: '{name}を削除しますか？',
} as const;

// @key: @#@"[RINGS_TYPE.Phone_Ring1]"@#@ @source: @#@"Phone Ring 1"@#@
// @key: @#@"[RINGS_TYPE.Phone_Ring2]"@#@ @source: @#@"Phone Ring 2"@#@
// @key: @#@"[RINGS_TYPE.Acoustic_Dreams]"@#@ @source: @#@"Acoustic Dreams"@#@
// @key: @#@"[RINGS_TYPE.Air_Raid]"@#@ @source: @#@"Air Raid"@#@
// @key: @#@"[RINGS_TYPE.Allusive]"@#@ @source: @#@"Allusive"@#@
// @key: @#@"[RINGS_TYPE.Attention]"@#@ @source: @#@"Attention"@#@
// @key: @#@"[RINGS_TYPE.Blub_Blub]"@#@ @source: @#@"Blub Blub"@#@
// @key: @#@"[RINGS_TYPE.Buzzy]"@#@ @source: @#@"Buzzy"@#@
// @key: @#@"[RINGS_TYPE.Channel_Open]"@#@ @source: @#@"Channel Open"@#@
// @key: @#@"[RINGS_TYPE.Contemplation]"@#@ @source: @#@"Contemplation"@#@
// @key: @#@"[RINGS_TYPE.Crystal_Ball]"@#@ @source: @#@"Crystal Ball"@#@
// @key: @#@"[RINGS_TYPE.Disco]"@#@ @source: @#@"Disco"@#@
// @key: @#@"[RINGS_TYPE.Door_Bell]"@#@ @source: @#@"Door Bell"@#@
// @key: @#@"[RINGS_TYPE.Fairy]"@#@ @source: @#@"Fairy"@#@
// @key: @#@"[RINGS_TYPE.Fast_Bells]"@#@ @source: @#@"Fast Bells"@#@
// @key: @#@"[RINGS_TYPE.High_Gong]"@#@ @source: @#@"High Gong"@#@
// @key: @#@"[RINGS_TYPE.Immersion]"@#@ @source: @#@"Immersion"@#@
// @key: @#@"[RINGS_TYPE.Indeed]"@#@ @source: @#@"Indeed"@#@
// @key: @#@"[RINGS_TYPE.Lazy_Day]"@#@ @source: @#@"Lazy Day"@#@
// @key: @#@"[RINGS_TYPE.Neural_Funk]"@#@ @source: @#@"Neural Funk"@#@
// @key: @#@"[RINGS_TYPE.Nice]"@#@ @source: @#@"Nice"@#@
// @key: @#@"[RINGS_TYPE.Ring]"@#@ @source: @#@"Ring"@#@
// @key: @#@"[RINGS_TYPE.Ringing_Bells]"@#@ @source: @#@"Ringing Bells"@#@
// @key: @#@"[RINGS_TYPE.Simple]"@#@ @source: @#@"Simple"@#@
// @key: @#@"[RINGS_TYPE.Soothing]"@#@ @source: @#@"Soothing"@#@
// @key: @#@"[RINGS_TYPE.Sunshine]"@#@ @source: @#@"Sunshine"@#@
// @key: @#@"[RINGS_TYPE.Off]"@#@ @source: @#@"Off"@#@
// @key: @#@"add"@#@ @source: @#@"Add"@#@
// @key: @#@"delete"@#@ @source: @#@"Delete"@#@
// @key: @#@"play"@#@ @source: @#@"Play"@#@
// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"confirmToDelete"@#@ @source: @#@"Delete {name}?"@#@
